:host {
  --aha-menu-content--initial-scale: scale(0.3);
  --aha-menu-content--initial-opacity: 0;
  --aha-menu-content--font-size: 13px;
  --aha-menu-content--padding-top: var(--aha-menu-content--vertical-padding);
  --aha-menu-content--padding-bottom: var(--aha-menu-content--vertical-padding);
  --popover-background: var(--theme-primary-background);

  font-weight: initial;

  top: var(--aha-menu-content--top, unset);
  bottom: var(--aha-menu-content--bottom, unset);
  left: var(--aha-menu-content--left, unset);
  right: var(--aha-menu-content--right, unset);

  /* Allow for adding margin. This is helpful to give some room from the triggering element. */
  margin-top: var(--aha-menu-content--vertical-margin, unset);
  margin-bottom: var(--aha-menu-content--vertical-margin, unset);

  transform-origin: center;

  animation: fadeIn cubic-bezier(0.39, 0.58, 0.57, 1) 0.3s;
  animation-iteration-count: 1;
  animation-fill-mode: forwards;

  display: none;
  background: var(--popover-background);
  border-radius: var(--Common--border-radius);
  width: max-content;
  min-width: 200px;
  box-shadow: var(--theme-shadow-shallow);
  border: 1px solid var(--theme-light-border);
  font-size: var(--aha-menu-content--font-size);
  box-sizing: border-box;
  outline: none;
  z-index: 10000;
  text-align: left;
}
:host([popover]) {
  /* It looks like browsers add padding to any element with a [popover] attribute.
  In this case, it's adding too much padding and making our menus look "chunky". */
  padding: 0;
}
:host([open]) {
  display: block;
}
:host([hide-children-when-closed]) * {
  display: none;
}
:host([hide-children-when-closed][open]) * {
  display: block;
}
* {
  box-sizing: border-box;
}
#inner {
  max-height: var(--aha-menu-content--max-height, calc(100vh - 2rem));
  max-width: var(--aha-menu-content--max-width, calc(100vw - 2rem));
  overflow: auto;
  padding-top: var(--aha-menu-content--padding-top);
  padding-bottom: var(--aha-menu-content--padding-bottom);
}
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
